import { SingleBusinessAddressType } from "types";
import * as Yup from "yup";

const noEmojiRegex = /\p{Extended_Pictographic}/u;

const addressRegex =
  /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i;

const postalcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export const businessAddressValidationSchema = Yup.object().shape({
  locationName: Yup.string()
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  address1: Yup.string()
    .matches(
      addressRegex,
      "No PO Boxes, business mailing addresses, or virtual mailboxes."
    )
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  address2: Yup.string()
    .optional()
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  city: Yup.string()
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  state: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  zip: Yup.string()
    .matches(
      postalcodeRegex,
      "Zip code should be 5 digits or 5+4 digits. For example, 10041 or 10041-0004."
    )
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  isHq: Yup.bool().optional(),
  subdivision: Yup.string().when("isHq", {
    is: (isHq: boolean) => !isHq || isHq === true,
    then: Yup.string().required("You missed this one"),
  }),
});

export const businessAddressValidationSchemaWC = Yup.object().shape({
  locationName: Yup.string()
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  address1: Yup.string()
    .matches(
      addressRegex,
      "No PO Boxes, business mailing addresses, or virtual mailboxes."
    )
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  address2: Yup.string()
    .optional()
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  city: Yup.string()
    .required("You missed this one")
    .max(50, "Less than 50 characters, please.")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  state: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  zip: Yup.string()
    .matches(
      postalcodeRegex,
      "Zip code should be 5 digits or 5+4 digits. For example, 10041 or 10041-0004."
    )
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
  isHq: Yup.bool().optional(),
  subdivision: Yup.string().optional(),
});

export interface BusinessAddressFormType {
  locationName?: string;
  address1: string;
  address2?: string;
  city: string;
  zip: string;
  state: string;
  uuid: string;
  isHq?: boolean;
  subdivision?: string;
}

export const BusinessAddressInitialFormValues = (
  formData?: SingleBusinessAddressType
): BusinessAddressFormType => {
  return {
    locationName: formData?.locationName || "",
    address1: formData?.address1 || "",
    address2: formData?.address2 || "",
    city: formData?.city || "",
    zip: formData?.zip || "",
    state: formData?.state || "",
    uuid: formData?.uuid || "",
    isHq: formData?.isHq,
    subdivision: formData?.subdivision || "",
  };
};
